import React from 'react';
import ContentGate from './ContentGate';

const Newsletter = () => {
  return (
    <div className="NewsletterPage-wrap" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: '20px' }}>
      <ContentGate standalone={true} />
    </div>
  );
};

export default Newsletter;
